import React from "react";
import { useColors } from "../../constants/Colors";

interface StepWrapperProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const StepWrapper: React.FC<StepWrapperProps> = ({
  title,
  subtitle,
  children,
}) => {
  const { textNeutralDefault, textNeutralMuted } = useColors();

  return (
    <div className="flex flex-col cf-step-enter">
      <div className="mb-8 text-center">
        <h2
          className="text-3xl sm:text-4xl font-gnarly-semibold leading-tight mb-3 tracking-tight"
          style={{ color: textNeutralDefault }}
        >
          {title}
        </h2>
        {subtitle && (
          <p
            className="text-sm sm:text-base leading-relaxed max-w-sm mx-auto"
            style={{ color: textNeutralMuted }}
          >
            {subtitle}
          </p>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default StepWrapper;
